import { render, staticRenderFns } from "./scrollerList.vue?vue&type=template&id=8350096a&scoped=true&lang=html&"
import script from "./scrollerList.vue?vue&type=script&lang=js&"
export * from "./scrollerList.vue?vue&type=script&lang=js&"
import style0 from "./scrollerList.vue?vue&type=style&index=0&id=8350096a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8350096a",
  null
  
)

export default component.exports